import { createLink } from '@tanstack/react-router'
import type { ComponentProps, ReactNode } from 'react'
import { cx } from './cx'

type CardStyle = {
  padded?: boolean
  /** Frosted, for a card that floats on a Stage picture. */
  glass?: boolean
}

const cardBase = 'block rounded-card border border-line bg-surface'
export const glassClass = 'rounded-card bg-surface/90 shadow-float ring-1 ring-ink/[0.06] backdrop-blur-xl'

const cardClass = (glass?: boolean) => (glass ? cx('block', glassClass) : cardBase)

type CardProps = Omit<ComponentProps<'div'>, 'className'> & CardStyle & { className?: string }

/** A self-contained unit. Use sparingly: sections are separated by space, not boxes. */
export function Card({ padded = true, glass, className, ...rest }: CardProps) {
  return <div className={cx(cardClass(glass), padded && 'p-5 md:p-6', className)} {...rest} />
}

type CardAnchorProps = Omit<ComponentProps<'a'>, 'className'> & CardStyle & { className?: string; children?: ReactNode }

function CardAnchor({ padded = true, glass, className, children, ...rest }: CardAnchorProps) {
  return (
    <a
      className={cx(
        cardClass(glass),
        padded && 'p-5 md:p-6',
        'transition-[background-color,border-color] duration-150 hover:border-line-strong hover:bg-bg-subtle',
        className,
      )}
      {...rest}
    >
      {children}
    </a>
  )
}

/** The whole card is one router link: `<CardLink to="/spiele/$id" params={{ id }}>`. */
export const CardLink = createLink(CardAnchor)
